module.exports = __webpack_public_path__ + "img/navidad.346c6d9b.png";